module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-quantum-cubic.3d456736.png";